// SubStory.js
import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./SubStory.css";

const paragraphVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const SubStory = ({ title, subtitle, paragraphs= [] }) => {
  return (
    <section className="substory-section">
      <div className="substory-content">
        {title && <h2 className="section-title">{title}</h2>}
        {subtitle && <p className="section-subtitle">{subtitle}</p>}

        <div className="section-paragraphs">
          {paragraphs.map((text, index) => {
            const [ref, inView] = useInView({ triggerOnce: false, threshold: 0.3 });
            return (
              <motion.p
                key={index}
                ref={ref}
                variants={paragraphVariant}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                className="animated-paragraph"
              >
                {text}
              </motion.p>
            );
          })}
          {/* <button className="explore-btn" onClick={onButtonClick}>
          {buttonText}
        </button> */}
        </div>
      </div>
    </section>
  );
};

export default SubStory;
